import { Card, CardBody, Heading, Link } from '@apollo/orbit';
import { Rocket2 } from '@apollo/space-kit/illustrations/Rocket2';
import React from 'react';

export const LaunchesEmptyState = () => {
  return (
    <Card className="flex-1">
      <CardBody className="items-center justify-center">
        <div className="w-120 text-center">
          <Rocket2 className="mb-4" />
          <Heading as="h1" size="3xl" className="mb-4">
            No launches found
          </Heading>
          <div className="mb-5 text-base">
            Publish a change to your schema to see details about your launch
            here. Learn more about this in the{' '}
            <Link
              isExternal
              to="https://www.apollographql.com/docs/rover/graphs/#publishing-a-schema-to-apollo-studio"
            >
              docs
            </Link>
            .
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
